import { Path } from 'react-hook-form';
import { CollectionMetadata } from '../types';
import { MetadataFieldWrapper } from './MetadataFieldWrapper';
import { useMetadataField } from '../hooks/useMetadataField';
import {
    parseIsoToDisplay,
    parseDisplayToIso,
} from '@common/utils/formatDuration';
import { TimecodeInput } from '@common/components/TimecodeInput';

export interface DurationMetadataFieldProps {
    name: Path<CollectionMetadata>;
}

export const DurationMetadataField = ({ name }: DurationMetadataFieldProps) => {
    const hookData = useMetadataField<string>({
        name,
        formatOption: parseIsoToDisplay,
    });
    const { field } = hookData;

    const currentDisplayValue = parseIsoToDisplay(field.value);

    const handleTimeChange = (newTimecode: string) => {
        field.onChange(parseDisplayToIso(newTimecode));
    };

    return (
        <MetadataFieldWrapper {...hookData}>
            <TimecodeInput
                value={currentDisplayValue}
                onChange={handleTimeChange}
            />
        </MetadataFieldWrapper>
    );
};
